import * as React from "react";

/** Highlights the first case-insensitive match of `query` in `text` using `<mark>`. */
export function highlightMatch(
  text: string | undefined | null,
  query: string | undefined | null,
  markClassName: string
): React.ReactNode {
  const safeText = text ?? "";
  const q = (query ?? "").trim();
  if (!q) {
    return safeText;
  }
  const lower = safeText.toLowerCase();
  const qi = q.toLowerCase();
  const idx = lower.indexOf(qi);
  if (idx === -1) {
    return safeText;
  }
  return (
    <>
      {safeText.slice(0, idx)}
      <mark className={markClassName}>{safeText.slice(idx, idx + q.length)}</mark>
      {safeText.slice(idx + q.length)}
    </>
  );
}
